import React from 'react';
    import { HashRouter as Router, Routes, Route } from 'react-router-dom';
    import { BrandKitProvider } from './contexts/BrandKitContext';
    import Layout from './components/Layout';
    
    import Dashboard from './pages/Dashboard';
    import ProcessPage from './pages/ProcessPage';
    import BrandKitPage from './pages/BrandKitPage';
    import PreviewPage from './pages/PreviewPage';
    
    import UploadTester from './pages/debug/UploadTester';
    import DropboxTester from './pages/debug/DropboxTester';
    import QuickUploader from './pages/debug/QuickUploader';
    
    // The ConfigurationWarning is no longer needed as we removed client-side Supabase logic
    // import { supabaseConfigurationError } from './supabase';
    // import ConfigurationWarning from './components/ConfigurationWarning';
    
    import './App.css';
    
    function App() {
      return (
        <BrandKitProvider>
          <Router>
            {/* <ConfigurationWarning error={supabaseConfigurationError} /> */}
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/process" element={<ProcessPage />} />
                <Route path="/brand-kit" element={<BrandKitPage />} />
                <Route path="/preview" element={<PreviewPage />} />
                <Route path="/debug/upload-tester" element={<UploadTester />} />
                <Route path="/debug/dropbox-tester" element={<DropboxTester />} />
                <Route path="/debug/quick-uploader" element={<QuickUploader />} />
              </Routes>
            </Layout>
          </Router>
        </BrandKitProvider>
      );
    }
    
    export default App;